var _defs, _mask, _use, _rect, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / square / JP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-etf-3",
    x: 0,
    y: 0,
    width: 24,
    height: 18,
    rx: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-square-/-JP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Japan",
    transform: "translate(0.000000, 3.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-etf-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-etf-3"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-77",
    fill: "#FFFFFF",
    xlinkHref: "#path-etf-3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-119-Copy",
    fill: "#FFFFFF",
    mask: "url(#mask-etf-3)",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-36",
    fill: "#BC002D",
    mask: "url(#mask-etf-3)",
    cx: 12,
    cy: 9,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-etf-3)",
    stroke: "#000000",
    strokeOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/JP.6ee1e7ff36b4f9c5229b6fff203fe130.svg";
export { ForwardRef as ReactComponent };